import * as React from "react";
import { Card, Stack, Typography, Divider, Box } from "@mui/material";
import { Assessment as AssessmentIcon } from "@mui/icons-material";
import { brand, text, neutral, surface, status } from "../../theme";

const formatINR = (v) =>
  `₹${(Number(v) || 0).toLocaleString("en-IN")}`;

export default function SummaryCard({ stats = {} }) {
  const rows = [
    {
      label: "Total LRs",
      value: stats.total_freight || 0,
      color: text.primary,
    },
    {
      label: "Total Bills",
      value: stats.total_billing || 0,
      color: text.primary,
    },
    {
      label: "Total Amount",
      value: formatINR(stats.total_amount),
      color: text.primary,
    },
    {
      label: "Received",
      value: formatINR(stats.received_amount),
      color: status.success.main,
    },
    {
      label: "Pending",
      value: formatINR(stats.pending_amount),
      color: brand.main,
    },
  ];

  return (
    <Card
      elevation={0}
      sx={{
        border: `1px solid ${neutral[200]}`,  /* was #E7EAF0 */
        borderRadius: "12px",
        p: 1.5,
        height: 250,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Stack
        direction="row"
        spacing={0.75}
        alignItems="center"
        sx={{ mb: 0.5 }}
      >
        <Box
          sx={{
            width: 22,
            height: 22,
            borderRadius: "5px",
            bgcolor: brand[50],
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <AssessmentIcon sx={{ fontSize: 13, color: brand.main }} />
        </Box>
        <Typography
          sx={{ fontWeight: 700, fontSize: "0.82rem", color: text.primary }}
        >
          Summary
        </Typography>
        <Typography sx={{ fontSize: "0.65rem", color: text.secondary }}>
        </Typography>
      </Stack>

      {/* Rows */}
      <Stack
        spacing={0}
        divider={<Divider sx={{ borderColor: surface.borderLight }} />}
        sx={{ flex: 1, justifyContent: "space-around" }}
      >
        {rows.map((r, i) => (
          <Stack
            key={i}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ py: 0.1 }}
          >
            <Typography
              sx={{ fontSize: "0.75rem", color: text.secondary, fontWeight: 500 }}
            >
              {r.label}
            </Typography>
            <Typography
              sx={{
                fontSize: "0.82rem",
                fontWeight: 700,
                color: r.color,
              }}
            >
              {r.value}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Card>
  );
}